import excelJS from 'exceljs'
import { save } from 'save-file'
import moment from 'moment-timezone'

const columns = [
  { name: "Timestamp", item: "ts", width: 24, format: "date" },
  { name: "Event Type", item: "event_type", width: 20 },
  { name: "Direction", item: "direction", width: 16, format: "direction" },
  { name: "Template", item: "template_name", width: 30 },
  { name: "Template ID", item: "template_id", width: 26 },
  { name: "Bundle", item: "bundle_name", width: 18 },
  { name: "Passes", item: "num_passes", width: 12 },
  { name: "Credits", item: "num_credits", width: 12, format: "credits" },
  { name: "Price", item: "price", width: 12, format: "currency" },
  { name: "VAT", item: "vat", width: 12, format: "currency" },
]

const creditUsageToExcel = async ({ fileName, data }) => {
  const workbook = new excelJS.Workbook()
  const font = { name: 'Courier', size: 12, bold: true }

  if (data.length) {
    const worksheet = workbook.addWorksheet("credit-usage")

    columns.forEach((col, idx) => {
      worksheet.getColumn(idx + 1).width = col.width
      worksheet.getRow(1).getCell(idx + 1).value = col.name
      worksheet.getRow(1).getCell(idx + 1).font = font
    })

    data.forEach((rowData, rowIndex) => {
      const row = worksheet.getRow(rowIndex + 2)
      columns.forEach((col, idx) => {
        row.getCell(idx + 1).value = col.format ? formatDataItem(rowData, col) : (rowData[col.item] ?? "")
        row.getCell(idx + 1).font = font
      })
    })
  }

  const buffer = await workbook.xlsx.writeBuffer()
  await save(buffer, fileName + '.xlsx')
}

export default creditUsageToExcel

const formatDataItem = (row, col) => {
  const value = row[col.item]

  switch (col.format) {
    case "date": return value ? moment(value, "YYYYMMDDHHmmSS").format("YYYY-MM-DD HH:mm:ss") : ""
    case "direction": return value === "topup" ? "credits added" : "credits spent"
    case "credits": return `${row.direction === "topup" ? "+" : "-"}${Number(value || 0).toLocaleString()}`
    case "currency": return value != null ? Number(value).toFixed(2) : ""
    default: return value ?? ""
  }
}
